import { render } from "./UserStatisticView.vue?vue&type=template&id=2ece264b&scoped=true"
import script from "./UserStatisticView.vue?vue&type=script&lang=js"
export * from "./UserStatisticView.vue?vue&type=script&lang=js"

import "./UserStatisticView.vue?vue&type=style&index=0&id=2ece264b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ece264b"]])

export default __exports__